var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCoinLarge = function SvgIconCoinLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.506 14.243c-1.299 4.77-6.16 7.632-10.857 6.393-4.698-1.239-7.453-6.11-6.154-10.88 1.298-4.769 6.159-7.631 10.857-6.392 4.697 1.238 7.452 6.109 6.154 10.879Z",
    fill: "#FFE91F",
    fillOpacity: 0.89
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.539 14.78c-1.594 5.853-7.586 9.428-13.442 7.883C3.242 21.12-.132 15.075 1.462 9.222 3.055 3.369 9.048-.206 14.903 1.338c5.856 1.544 9.23 7.589 7.636 13.442ZM9.743 20.293c4.51 1.189 9.177-1.56 10.423-6.139 1.247-4.58-1.398-9.256-5.908-10.445-4.51-1.19-9.177 1.559-10.424 6.138-1.247 4.58 1.398 9.256 5.909 10.446Z",
    fill: "#E59722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.858 13.808c-1.055 3.875-4.982 6.208-8.77 5.21-3.79-1-6.004-4.95-4.949-8.825 1.056-3.876 4.983-6.208 8.771-5.21 3.789 1 6.004 4.95 4.948 8.825Z",
    fill: "#FFCF23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.33 14.458c-1.413 5.184-6.708 8.4-11.915 7.027-5.207-1.372-8.159-6.76-6.746-11.945 1.412-5.184 6.707-8.4 11.914-7.027 5.208 1.373 8.159 6.76 6.747 11.945Zm-11.242 4.558c3.788.998 7.715-1.334 8.77-5.21 1.056-3.874-1.159-7.825-4.947-8.824-3.789-.998-7.716 1.334-8.771 5.21-1.056 3.874 1.16 7.825 4.948 8.824Z",
    fill: "#E59722"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.265 7.015a6.886 6.886 0 0 0-2.786-1.477c-3.789-.998-7.716 1.334-8.772 5.21-.682 2.504.002 5.04 1.594 6.79-1.99-1.74-2.92-4.563-2.161-7.348 1.055-3.875 4.982-6.207 8.77-5.209a6.889 6.889 0 0 1 3.355 2.034Z",
    fill: "#FFDD65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.888 10.034C14.534 8.861 13.375 8 12 8h-.005c-1.206 0-2.245.662-2.722 1.616h.005A2.616 2.616 0 0 0 9 10.79c0 1.541 1.343 2.79 3 2.79 0 0-.476 1.594-1.516 2.421 0 0 3.783-1.352 4.454-4.593.037-.18.062-.434.062-.618 0-.261-.04-.514-.112-.755Z",
    fill: "#E59722"
  })));
};
export default SvgIconCoinLarge;